import { Button, Popconfirm, Space, Table, TableColumnType, Tag } from "antd";
import {
  useDeletePermission,
  useGetAllPermissions,
} from "../../query/PermissionQuery";
import ModalActionPermission from "../../components/modal/ModalActionPermission";

import { useState } from "react";
import { notify } from "../../utils/toast";

interface FlatPermission {
  key: string;
  permissionCode?: string;
  title: string;
  description?: string;
  action?: string;
  resource?: string;
  isGroup: boolean;
  groupTitle?: string;
}

const PermissionSystem = () => {
  const { data: permissions, isLoading: isLoadingPermissions } =
    useGetAllPermissions();
  const deletePermission = useDeletePermission();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [permission, setPermission] = useState<FlatPermission | null>(null);
  const flatData: FlatPermission[] = [];
  permissions?.forEach((group) => {
    flatData.push({
      key: group.key,
      title: group.title,
      isGroup: true,
    });
    group.children?.forEach((child) => {
      flatData.push({
        key: `${group.key}-${child.key}`,
        permissionCode: child.permissionCode,
        title: child.title,
        description: child.description,
        action: child.action,
        resource: child.resource,
        isGroup: false,
        groupTitle: group.title,
      });
    });
  });

  const columns: TableColumnType<FlatPermission>[] = [
    {
      title: "Mã quyền",
      dataIndex: "permissionCode",
      key: "permissionCode",
      width: 200,
      render: (text, record) =>
        record.isGroup ? (
          <span className="font-bold">{record.title}</span>
        ) : text ? (
          <Tag color="blue">{text}</Tag>
        ) : (
          "-"
        ),
    },
    {
      title: "Tên quyền",
      dataIndex: "title",
      key: "title",
      width: 200,
      render: (text, record) => (record.isGroup ? null : <span>{text}</span>),
    },
    {
      title: "Mô tả",
      dataIndex: "description",
      key: "description",
      width: 200,
      render: (text, record) => (record.isGroup ? null : text || "-"),
    },
    {
      title: "Hành động",
      dataIndex: "action",
      key: "action",
      width: 120,
      render: (text, record) =>
        record.isGroup ? null : text ? <Tag color="cyan">{text}</Tag> : "-",
    },
    {
      title: "Tài nguyên",
      dataIndex: "resource",
      key: "resource",
      width: 120,
      render: (text, record) =>
        record.isGroup ? null : text ? <Tag color="green">{text}</Tag> : "-",
    },
    {
      title: "Chỉnh sửa",
      dataIndex: "edit",
      key: "edit",
      width: 120,
      render: (text, record) =>
        record.isGroup ? null : (
          <>
            <Space>
              <Button
                onClick={() => {
                  setPermission(record);
                  setOpenModal(true);
                }}
                type="primary"
                size="small"
              >
                Sửa
              </Button>
              <Popconfirm
                title="Xóa quyền"
                description="Bạn có chắc chắn muốn xóa quyền này?"
                onConfirm={async () => {
                  try {
                    await deletePermission.mutateAsync(
                      Number(record.key.split("-")[1])
                    );
                    notify.success("Xóa quyền thành công");
                  } catch (error) {
                    notify.error("Xóa quyền thất bại");
                  }
                }}
                okText="Xóa"
                cancelText="Hủy"
              >
                <Button danger size="small">
                  Xóa
                </Button>
              </Popconfirm>
            </Space>
          </>
        ),
    },
  ];

  const handleCreateNew = () => {
    setPermission(null);
    setOpenModal(true);
  };

  return (
    <div className="p-4">
      <div className="mb-4">
        <Button type="primary" onClick={handleCreateNew}>
          Tạo quyền mới
        </Button>
      </div>
      <Table
        columns={columns}
        dataSource={flatData}
        loading={isLoadingPermissions}
        rowKey={(record) => record.key}
        pagination={{
          pageSize: 12,
          showSizeChanger: true,
        }}
        scroll={{ x: 1000 }}
      />
      <ModalActionPermission
        open={openModal}
        permission={permission}
        onCancel={() => {
          setOpenModal(false);
          setPermission(null);
        }}
      />
    </div>
  );
};

export default PermissionSystem;
